import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { Col, Button, DropdownButton, Dropdown, InputGroup, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//icons
import { BiSearch } from 'react-icons/bi';
// constants
import { searchChoiceData } from '../../constants'; 
// components
import SearchBar from './SearchBar';

const SearchBarDesktop = ({ isDesktop, secondaryImage = false }) => {
  const { t } = useTranslation(['header']);
  const FORM_RADIO_OPTIONS_DIVISIONS = searchChoiceData(t);

  const initialSearchValues = {
    searchText: '',
    searchType: 'products'
  };

  return (
    <Col lg={!secondaryImage ? 7 : 6} className="header__search desktop ">
      <div className="search-desktop " data-testid="search-desktop">
        <SearchBar
          isDesktop={isDesktop}
          initialValues={initialSearchValues}
        >
          <DropdownButton
            as={InputGroup.Text}
            variant="outline-dark"
            title={t('opcionesBusqueda')}
            id="input-group-dropdown-2"
            className="border-0"
          >
            <Form.Group>
              {FORM_RADIO_OPTIONS_DIVISIONS?.map(({ name, optionsData }, index) => {
                return (
                  <React.Fragment key={`divition#${index}`}>
                    <Form.Label as="legend" column lg={12}>
                      {name}
                    </Form.Label>
                    <Col lg={12}>
                      {optionsData?.map((optionData, idx) => (
                        <Field
                          as={Form.Check}
                          key={`radioOption#${idx}`}
                          type={[0, 1].includes(index) ? "radio" : "checkbox"}
                          id={optionData.label}
                          {...optionData}
                          className="flex-0"
                        />
                      ))}
                    </Col>
                    {index < FORM_RADIO_OPTIONS_DIVISIONS.length - 1 && <Dropdown.Divider className='border-2' />}
                  </React.Fragment>
                );
              })}
            </Form.Group>
            <Dropdown.Item 
              variant="primary" 
              type="submit" 
              className="btn-desktop-search" 
              as={Button}
            >
              <BiSearch data-testid="icon-search"/>{t('search')}
            </Dropdown.Item>
          </DropdownButton>
          <InputGroup.Text>
            <Button type="submit" className="deskt-search ">
              {t('search')} 
            </Button>
          </InputGroup.Text>
        </SearchBar>
      </div>
    </Col>
  );
}

SearchBarDesktop.propTypes = {
  isDesktop: PropTypes.bool,
  secondaryImage: PropTypes.bool
};

export default SearchBarDesktop;

